
import React, {
  PropTypes
} from 'react';

import {
  Image
} from 'react-bootstrap';

const Header = ({ item }) => {
  const { title, img, url } = item;

  return (
    <div>
      <a href={url} target="_blank">
        <Image src={img} />
      </a>

      <a href={url} target="_blank">
        <h3>{title}</h3>
      </a>
    </div>
  );
};

Header.propTypes = {
  item: PropTypes.shape().isRequired
};

export default Header;



// WEBPACK FOOTER //
// ./src/components/projects/Header.js